import React from 'react';
import CreateComboGroupState from './createComboGroupState/CreateComboGroupState';
import ControlPanel from './components/ControlPanel/ControlPanel';
import Forms from './components/Forms/Forms';
import { ModalWindows } from './components/ModalWindows';

const CreateComboGroupPage: React.FC = () => {
	return (
		<CreateComboGroupState>
			<ControlPanel />
			<Forms />
			<ModalWindows />
		</CreateComboGroupState>
	);
};

export default CreateComboGroupPage;
